export enum MessageType {
  LoggedIn = 0,
  LogOut = 1,
  Quit = 2,
  UpdateSettings = 3,
  ResizeCurrentWindow = 4,
  OpenNewWindow = 5,
  OpenInBrowser = 6,
  RedirectCurrentView = 7,
  Version = 8,
  CenterCurrentWindow = 9,
  RepositionCurrentWindowMessage = 10,
  LoggingMessage = 11,
  ChangeTrayIconMessage = 12,
  BringToFront = 13,
  Command = 14,
  UrlProtocolMessage = 15,
  ExtendTeamsToast = 16,
  OpenLogFolder = 17,
  PreviewZoom = 18,
  Topmost = 19,
}
